





































































































































































































































































































































































































































    import AbpBase from "../../../lib/abpbase";
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import conEdit from './conEdit.vue'
    import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
    import Util from '../../../lib/util'
    import Form from './makePrescriptionForm'
    import {GetRecipeData,Prescribe,GetDlySates,GetPatBeforeDryWeightData,GetAntiMedicineListByType} from '../../../api/dialysisProcess'

    import {GetListByCode} from '../../../api/configureDictionary/'
    import {GetAntiMedicineList,GetConsByType} from '../../../api/configureDictionary'


    @Component({
        components:{conEdit,multipleDataEchart}
    })
    export default class  extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:{}}) data:any;

        dataE = {}

        //左右tabs
        tabsShow = 1
        //透析模式
        txTypes = []
        //当前选择
        txType = 0
        //耗材编辑弹窗
        conEditShow = false
        conEdit(){
            this.conEditShow = true
        }
        form:any = new Form()
        columns1= [
            {
                title: 'Name',
                key: 'name'
            },
            {
                title: 'Age',
                key: 'age'
            },
            {
                title: 'Address',
                key: 'address'
            }
        ]
        //偏移量
        offsetVdr = (rule:any, value:any, callback:any) => {
            if (this.form.dialysisRecipe.offset>=this.form.dialysisRecipe.jWeight) {
                callback(new Error('偏移量不能大于等于净体重'));
            } else {
                callback();
            }
        }

        //净体重干体重
        sbpChange(){
            //净体重
            this.form.dialysisRecipe.jWeight=this.form.dialysisRecipe.beforeWeight-this.form.dialysisRecipe.offset
            //称量体重
            this.form.dialysisRecipe.beforeWeight = this.form.dialysisRecipe.jWeight+this.form.dialysisRecipe.offset
            //偏移量
            this.form.dialysisRecipe.offset=this.form.dialysisRecipe.beforeWeight-this.form.dialysisRecipe.jWeight
            //极限值
            this.form.dialysisRecipe.ultrafiltrationVolume = Number(this.form.dialysisRecipe.jWeight-this.form.dialysisRecipe.dryWeight)*1000+this.form.dialysisRecipe.backWater
        }

        //超滤量
        ultrafiltrationVolumeVdr = (rule:any, value:any, callback:any) => {
            if (this.form.dialysisRecipe.offset>=this.form.dialysisRecipe.dryWeight) {
                callback(new Error('偏移量不能大于等于净体重'));
            } else {
                callback();
            }
        }

        //表单验证

        //抗凝model
        abtiWaysModel:any = {
            antiWays:null,
            // 抗凝方式（数据字典对应的Id）
            medId:null,
            // 抗凝剂对应药品id
            antiFirstDose:null,
            // 首剂
            antiFirstUnit:null,
            // 首剂单位
            antiAddDose:null,
            // 追加/小时
            dose:null,
            // 枸橼酸剂量(ml/h)
            gaMedId:null,
            // 钙剂药品Id
            gaDose:null,
            // 钙剂剂量(ML)
            normalSalineMedId:null,
            // 生理盐水药品Id
            normalSalineDose:null,
            // 生理盐水剂量（ML）
            pumpDose:null,
            // 泵 入( ml/h)
        }

        //抗凝多选表格
        antiWaysColumn:any = [

        ]
        antiDelete(index:any){
            this.antiWaysList.splice(index, 1);
        }
        antiWaysList:any = []
        addAntiWays(){
            let flag = true
            this.antiWaysList.forEach((item:any) => {
                if(this.abtiWaysModel.antiWays == item.antiWays){
                    flag = false
                }
            });
            if(!flag){
                this.$Message.info("抗凝方式只可选择一种")
                return false
            }

            let data = Object.assign({},this.abtiWaysModel)
            this.antiWaysList.push(data)
            console.log(this.antiWaysList)
            //清空
            this.abtiWaysModel.medId = null
            this.abtiWaysModel.antiFirstDose = null
            this.abtiWaysModel.antiAddDose = null
            this.abtiWaysModel.dose = null
            this.abtiWaysModel.gaMedId = null
            this.abtiWaysModel.gaDose = null
            this.abtiWaysModel.normalSalineMedId = null
            this.abtiWaysModel.normalSalineDose = null
            this.abtiWaysModel.pumpDose = null
        }

        //抗凝药品
        antiWaysDrugs:any = []
        //所有抗凝药品
        antiWaysDrugAll:any = []
        antiWaysType = ''
        //抗凝模式
        antiWaysChange(){
            //清空
            this.abtiWaysModel.medId = null
            this.abtiWaysModel.antiFirstDose = null
            this.abtiWaysModel.antiAddDose = null
            this.abtiWaysModel.dose = null
            this.abtiWaysModel.gaMedId = null
            this.abtiWaysModel.gaDose = null
            this.abtiWaysModel.normalSalineMedId = null
            this.abtiWaysModel.normalSalineDose = null
            this.abtiWaysModel.pumpDose = null
            //抗凝方式名称
            this.antiWaysDrugAll = []
            this.anticoagulationWaysOptions.forEach((item:any)=>{
                if(this.abtiWaysModel.antiWays == item.id){
                    this.antiWaysDrugs = item.items
                    this.antiWaysType = item.alSubclass
                }
                if(item.items){
                    this.antiWaysDrugAll.push(...item.items)
                }
            })
            console.log(this.antiWaysDrugAll)

            //默认加载第一条
            if(this.antiWaysType!='无肝素'){
                this.abtiWaysModel.medId = this.antiWaysDrugs[0].anticoagulateMedId
            }


        }
        async created() {
            this.form = new Form()
            await this.getListByCode()
            await this.getRecipeData()
            await this.getAntiMedicineList()
            await this.getDlySates()
            await this.getPatBeforeDryWeightData()
            await this.getAntiMedicineListByType()
            this.antiWaysColumn = [
                {
                    key:'antiWaysType',
                    title:'抗凝方式',
                    render: (h:any ,params:any)=>{
                        return h('span',this.anticoagulationWaysOptions.find((item:any)=>{return item.id == params.row.antiWays}).alSubclass)
                    }
                },{
                    key:'medName',
                    title:'抗凝药品',
                    render: (h:any ,params:any)=>{
                        return h('span',params.row.medId
                        ?this.antiWaysDrugAll.find((item:any)=>{return item.anticoagulateMedId == params.row.medId}).anticoagulateMedName+'('+
                        this.antiWaysDrugAll.find((item:any)=>{return item.anticoagulateMedId == params.row.medId}).medicineModel+')'
                        :'')
                    }
                },{
                    key:'antiFirstDose',
                    title:'首剂',
                },{
                    key:'antiFirstUnit',
                    title:'首剂单位',
                },{
                    key:'antiAddDose',
                    title:'追加/小时',
                },{
                    key:'dose',
                    title:'枸橼酸剂量(ml/h)',
                },{
                    key:'gaMedName',
                    title:'钙剂药品',
                    render: (h:any ,params:any)=>{
                        return h('span',params.row.gaMedId?this.gaMedOptions.find((item:any)=>{return item.id == params.row.gaMedId}).medicineName:'')
                    }
                },{
                    key:'gaDose',
                    title:'钙剂剂量',
                },{
                    key:'normalSalineMedName',
                    title:'生理盐水药品',
                    render: (h:any ,params:any)=>{
                        return h('span',params.row.normalSalineMedId?this.normalSalineMedOptions.find((item:any)=>{return item.id == params.row.normalSalineMedId}).anticoagulateMedName:'')
                    }
                },{
                    key:'normalSalineDose',
                    title:'生理盐水剂量',
                },{
                    key:'pumpDose',
                    title:'泵 入',
                },{
                    title: this.L('Actions'),
                    key: 'Actions',
                    width: 70,
                    render: (h: any, params: any) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.antiDelete(params.add)
                                    }
                                }
                            }, '删除'),
                        ])
                    }
                }
            ]
        }

        async mounted(){
            // this.form = new Form()
            this.$nextTick(()=>{
                this.offsetVdr = (rule:any, value:any, callback:any) => {
                    if (this.form.dialysisRecipe.offset>=this.form.dialysisRecipe.jWeight) {
                        callback(new Error('偏移量不能大于等于净体重'));
                    } else {
                        callback();
                    }
                }
            })

        }
        //获取干体重
        async getPatBeforeDryWeightData(){
            let data = {
                DialysisWay:this.data.dialysisWay.split('/')[0] || this.data.dialysisWay,
                PatientId:this.data.patientId
            }
            let res = await GetPatBeforeDryWeightData(data)
            this.form.dialysisRecipe.dryWeight = Number(res.objects.dryWeight)
        }

        //血管通路list
        patVasList:any = []
        //耗材列表
        consList:any = {
            list:[]
        }

        //极限值超滤量
        JXultrafiltrationVolume = 0
        //抗凝方式
        anticoagulationWaysOptions:any = []

        recipeReject:any = {}
        //获取处方加载下拉框
        async getRecipeData(){
            //处方id 有值时  只传处方id
            let data:any = {}
            if(this.data.recipeId){
                data = {
                    RecipeId:this.data.recipeId,
                }
            }else{
                data = {
                    patientId:this.data.patientId,
                    dialysisWay:this.data.dialysisWay.split('/')[0]
                }
            }
            let res = await GetRecipeData(data);
            console.log(res.objects.dialysisSign)
            //处方信息
            if(res.objects.recipe){
                this.form.dialysisRecipe = Object.assign(res.objects.recipe,{})
                this.form.recipeConsumables = res.objects.recipe.recipeConsumables
                this.form.recipeAntis = res.objects.recipe.recipeAntis
                this.consList.list = res.objects.recipe.recipeConsumables
                this.antiWaysList = res.objects.recipe.recipeAntis
                console.log(this.form)
                //耗材选择加载
                this.conEditShow = true

                //体重信息
                this.form.dialysisRecipe.beforeDbp = res.objects.dialysisSign.beforeDbp
                this.form.dialysisRecipe.beforeSbp = res.objects.dialysisSign.beforeSbp
                this.form.dialysisRecipe.beforeWeight = res.objects.dialysisSign.beforeWeight
                this.form.dialysisRecipe.heartRate = res.objects.dialysisSign.heartRate
                this.form.dialysisRecipe.jWeight=this.form.dialysisRecipe.beforeWeight-this.form.dialysisRecipe.offset

            }else{

            }
            //拒绝信息
            if(res.objects.recipeReject){
                this.recipeReject = res.objects.recipeReject
            }


            //极限值超滤量
            this.JXultrafiltrationVolume = Number(this.form.dialysisRecipe.jWeight-this.form.dialysisRecipe.dryWeight)*1000+this.form.dialysisRecipe.backWater
            this.form.dialysisRecipe.ultrafiltrationVolume = Number(this.form.dialysisRecipe.jWeight-this.form.dialysisRecipe.dryWeight)*1000+this.form.dialysisRecipe.backWater

            //血管通路
            this.patVasList = res.objects.patVas
            if(this.patVasList){
                this.form.dialysisRecipe.patVaId = this.patVasList[0].id
            }




        }
        //获取透析模式
        async getListByCode(){
            let res = await GetListByCode({input:'025'})
            this.txTypes = res;
            //默认选择第一个
            this.form.dialysisRecipe.dialysisWay = res[0].text
            this.antiWaysType = res[0].alSubclass
        }
        //获取抗凝方式
        async getAntiMedicineList(){
            let res = await GetAntiMedicineList()
            //抗凝方式
            this.anticoagulationWaysOptions = res
            //默认加载第一条
            this.abtiWaysModel.antiWays = res[0].id
            this.antiWaysType = res[0].alSubclass
            this.antiWaysChange()
        }
        //获取钙剂和生理盐水
        gaMedOptions:any = []
        normalSalineMedOptions:any = []
        async getAntiMedicineListByType(){
            let res = await GetAntiMedicineListByType({medType:1078})
            this.gaMedOptions = res
            let res1 = await GetAntiMedicineListByType({medType:1116})
            this.normalSalineMedOptions = res1
        }
        dlySatesList = []
        //获取透析液
        async getDlySates(){
            let res = await GetDlySates()
            this.dlySatesList = res.objects
        }
        //浓度颜色
		caColor = ''
        dlySatesChange(val:any){
            this.dlySatesList.forEach((item:any)=>{
                if(val==item.dialysateCa){
                    this.form.dialysisRecipe.dialysateconcNa = item.dialysateNa
                    this.form.dialysisRecipe.dialysateconcK = item.dialysateK
                    this.form.dialysisRecipe.dialysateconcGlucose = item.dialysateSugar
                    this.form.dialysisRecipe.dialysateconcHco3 = item.dialysateHco3
                    this.form.dialysisRecipe.dialysateconcMg = item.dialysateMg
                    this.form.dialysisRecipe.dialysateconcCl = item.dialysateCl
                    this.form.dialysisRecipe.dialysateconcK = item.dialysateAa
                }
                switch(String(val)){
                    case "1.75":
					this.caColor = 'red'
					break;
				case '1.5':
					this.caColor = '#0f0'
					break
				case "1.25":
					this.caColor = 'rgb(223, 225, 19)'
                    break;
                }
            })

        }

        //耗材带回
        async consBack(data:any){
            this.form.recipeConsumables = data
        }
        save(){
            //抗凝加入
            this.form.recipeAntis = this.antiWaysList;

            if(this.form.dialysisRecipe.assessList){
                this.form.dialysisRecipe.assess = this.form.dialysisRecipe.assessList.join(',')
            }
            this.form.dialysisRecipe.dialysisSignId = this.data.dialysisSignId
            this.prescribe(this.form)

        }
        //确认处方
        async prescribe(data:any){
            let res = await Prescribe(data)
            console.log(res)
            if(res.status == 1){
                // this.$Message.success('保存成功')
                this.$emit('input',false);
                this.$emit('on-success')
            }else{
                // this.$Message.error(res.message)
            }
        }


        //////////历史数据
        hisType:any = ['综合数据','患者评估','并发症','抗凝模式','透前血压','透后血压','体重','实际体重变化','干体重','实际超滤量']
        hisTypeActive = '综合数据'
        hisTypeCh = true
        hisData:any = {
            type:'line',
            legendName:['称量体重'],
            name:'rec'
        }
        cancel(){
            (this.$refs.roleForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/waitRoom/makePrescription.vue